import React from "react";

const OverviewYEE = () => {
  return (
    <div className="flex md:space-x-2">
      <div className="md:w-3/4">
        <div className="border-2 p-2 border-sdorange inline-block mb-1 ">
          <p>Course Overview</p>
        </div>
        <div>
          <img src="/image-fix/random-images/young-emerging-entepreneur.jpg" />
        </div>
        <div id="overview">
          <p className="text-justify">
            The Young Emerging Entrepreneur course offers an immersive
            exploration into the realm of entrepreneurship, equipping students
            with a comprehensive understanding of the principles and practices
            essential for venturing into the dynamic world of business. This
            course transcends conventional learning approaches by integrating
            theoretical frameworks with real-world case studies, fostering a
            holistic comprehension of entrepreneurial dynamics. Throughout the
            curriculum, students delve into vital aspects such as ideation,
            business planning, and strategic management, culminating in the
            cultivation of essential skills imperative for the inception and
            sustenance of successful ventures.
          </p>
        </div>
      </div>

      <div className="md:w-1/4 hidden p-2 rounded-lg border-2 border-sdorange bg-sdbodywhiteywhitebody md:flex items-center">
        {" "}
        <img
          src="/image-fix/academic-programmes/executive-education/schima.png"
          className="w- w-full"
        />
      </div>
    </div>
  );
};

export default OverviewYEE;
